import Cookies from "js-cookie";
import {ID_TOKEN, PATH, TIME_LOGOUT} from "../../conf";
import {showToast} from "../../components/general/CustomToast";

const getMessage = (status: number) => {
  switch (status) {
    case 500:
      return 'Ha ocurrido un error interno, comuníquese con el administrador.';
    case 400:
      return 'Las credenciales de acceso, usuario o contraseña son incorrectos.';
    case 401:
      return 'Las credenciales de acceso, usuario o contraseña son incorrectos.';
    case 403:
      return 'Usuario no autorizado para acceso a esta función.';
    case 404:
      return 'No existen registros que mostrar.';
    case -888:
      return 'Ha ocurrido un problema capturando el error, comuníquese con el administrador.';
    default:
      return 'Problemas de conexión, intente después de unos minutos.';
  }
};

export function errorHandlerServices(error: any, redirect: boolean, dontViewToast?: boolean) {
  if (error.response) {
    if (error?.response?.status === 401) {
      Cookies.remove(ID_TOKEN);
      if (redirect) {
        showToast(
            'Sesión caducada',
            'error'
        );

        setTimeout(() => {
          window.location.href = PATH;
        }, TIME_LOGOUT);
      }
    }
    let msgError = getMessage(error.response.status);
    if (error?.response?.status !== 401 && error.response.data && error.response.data.message) {
      msgError = error.response.data.message;
      if (dontViewToast === undefined || !dontViewToast) showToast(msgError, 'error');
    } else {
      if (dontViewToast === undefined || !dontViewToast) showToast(error.response.data.error_description, 'error');
    }
  } else {
    if (dontViewToast === undefined || !dontViewToast) showToast(error?.toString(), 'warning-info');
  }
}

export default function errorHandler(error: any, dispatch: any, typeAction: any) {
  if (error.response) {
    if (error?.response?.status === 401) {
      Cookies.remove(ID_TOKEN);
      showToast(
          'Sesión caducada',
          'error'
      );
      setTimeout(() => {
        window.location.href = PATH;
      }, TIME_LOGOUT);
    }
    let msgError = getMessage(error.response.status);
    if (error.response.data && error.response.data.message) {
      msgError = error.response.data.message;
    }
    dispatch({
      type: typeAction,
      payload: msgError,
    });
  } else {
    let msgError = getMessage(-888);
    dispatch({
      type: typeAction,
      payload: msgError,
    });
  }
}
